import React , {useEffect} from "react";
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
// import Services from "../components/Sections/Services";
import Projects from "../components/Sections/Projects";
import Blog from "../components/Sections/Blog";
import Pricing from "../components/Sections/Pricing";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer"
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

export default function Landing() {
  const location = useLocation();
  useEffect(() => {
    const section = location.state?.scrollTo;
    if (section) {
      setTimeout(() => {
        scroller.scrollTo(section, {
          duration: 600,
          smooth: true,
          offset: -80, 
        });

        try {
          window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
        } catch (e) {
        }
      }, 50);
    }
  }, [location]);
  return (
    <>
      <TopNavbar />
      <Header />
      {/* <Services />   */}
      <Projects />
      {/* <Blog /> */}
      {/* <Pricing /> */}
      <Contact />
      <Footer />
    </>
  );
}


